const POINTS_EXCHANGE_TYPE_VALUES = {
    EXCHANGE: 1,
    BUY: 2,
}

const POINTS_EXCHANGE_TYPES = [{
    labelKey: "PointsExchange.listing.exchangePointsTitle",
    value: POINTS_EXCHANGE_TYPE_VALUES.EXCHANGE,

}, {
    labelKey: "PointsExchange.listing.buyPointsTitle",
    value: POINTS_EXCHANGE_TYPE_VALUES.BUY,
}]


const INITIAL_POINTS_EXCHANGE_TYPE_VALUE = POINTS_EXCHANGE_TYPES?.[0]?.value;


export {
    POINTS_EXCHANGE_TYPES,
    POINTS_EXCHANGE_TYPE_VALUES,
    INITIAL_POINTS_EXCHANGE_TYPE_VALUE
}
